// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3T6Kb","covid19logo":"App_covid19logo__3_-Nk"};